
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import styles from './clientDetailsPop.module.css';
import pageStylePops from './pageStylePops.module.css';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import {
    theMenuItems
} from '../FAKEDB/fakes'
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import PopUpClearComp from './PopUpClearComp';
import ConnectPop from './ConnectPop';
import RegisterPagePop from './RegisterPagePop';
import { UserContext } from '../Contexts/User_Context';

const ClientDetailsPop = (props) => {

    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction, logout] = useContext(UserContext);

    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();
    const [thePopUp, setThePopUp] = useState();

    useEffect(() => {
    }, [mobiOrNot]);

    useEffect(() => {


    }, [])

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSpecialPages.getStaticPageByName("LogOrRegPage")
            setPageDetails(pg);
        }
        getPageDetalis();
    }, [])

    const disconnect = () => {
        logout();
        props.closeMeFuc();

    }
    const myOrders = () => {
        navigate("/myOrders")

        props.closeMeFuc();

    }

    const myDetails = () => {
    }

    return (
        <div className={`${pageStylePops.topPlace} regularPoint`}>
            {user && <>
                <div className={pageStylePops.contentPlaceWrap}>
                    <br />
                    <br />
                    <div className={`${pageStylePops.loginPageBtns}  inBackGold inColorWhite pointing`} onClick={() => disconnect()}>
                        <div>התנתק</div>
                    </div>
                    <div className={`${pageStylePops.loginPageBtns} inBackMiiddleGold inColorBlack pointing`} onClick={() => myDetails()}>
                        <div>הפרטים שלי</div>
                    </div>
                    <div className={`${pageStylePops.loginPageBtns} inBackBlue inColorWhite pointing`} onClick={() => myOrders()}>
                        <div>ההזמנות שלי</div>
                    </div>
                </div>
            </>
            }
            {thePopUp}
        </div >


    );
}

export default ClientDetailsPop;
